/* eslint-disable */
import React, { useEffect, useContext, useState } from "react";
import Select from "react-select";

//import translation function for language translation
import { useTranslation } from "react-i18next";

/*import url and gateway methods */
import { postData, putData } from "utils/Gateway";
import * as url from "urlhelpers/UrlHelper";

//import option
import reserveOptions from "data/Prod/LabelReserveOptions.json";

//import context
import { GlobalProvider } from "context/GlobalContext";

const AddUpdateConceptPopup = () => {
  const token = localStorage.getItem("token"); // token
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  const { t } = useTranslation(); //for translation

  const {
    resetAddUpdateConceptPopup,
    setResetAddUpdateConceptPopup,
    setReloadConceptList,
    editConceptData,
    setEditConceptData,
    setSuccess,
    setError,
    setNotificationString,
  } = useContext(GlobalProvider);

  const [conceptName, setConceptName] = useState("");
  const [isSending, setIsSending] = useState(false);

  /* hook for validation */
  const [validation, setValidation] = useState({
    nameWarning: false,
  });

  /* function to validate form */
  const validate = () => {
    let isValid = true;

    if (conceptName === "") {
      setValidation((prevState) => ({ ...prevState, nameWarning: true }));
      isValid = false;
    }

    return isValid;
  };

  /* function to add label */
  const addNewConceptHandler = async (e) => {
    e.preventDefault();

    let labelData = {
      name: conceptName,
    };

    if (validate()) {
      setIsSending(true);
      try {
        let requestUrl =
          url.API_BASEURL + url.API_ADD_NEW_CONCEPT + `?token=${token}`;

        const response = await postData(requestUrl, labelData);

        if (response.status) {
          setIsSending(false);
          resetHandler();
          setReloadConceptList(true);
          setSuccess(true);
          setNotificationString(t("Concept added successfully"));
        }
      } catch (error) {
        console.error(error.message);
        setError(true);
        setNotificationString(
          t("Something went wrong, please try again later")
        );
      }

      bootstrap.Offcanvas.getInstance(
        document.querySelector("#addUpdateConceptPopup")
      ).hide();
    }
  };

  //function for update material kit
  const updateConceptHandler = async (e) => {
    e.preventDefault();

    let labelData = {
      name: conceptName,
    };

    if (validate()) {
      setIsSending(true);
      try {
        let requestUrl =
          url.API_BASEURL +
          url.API_UPDATE_CONCEPT +
          `/${editConceptData._id}` +
          `?token=${token}`;

        const response = await putData(requestUrl, labelData);

        if (response.status) {
          setIsSending(false);
          resetHandler();
          setReloadConceptList(true);
          setSuccess(true);
          setNotificationString(t("Concept added successfully"));
        }
      } catch (error) {
        console.error(error.message);
        setError(true);
        setNotificationString(
          t("Something went wrong, please try again later")
        );
      }

      bootstrap.Offcanvas.getInstance(
        document.querySelector("#addUpdateConceptPopup")
      ).hide();
    }
  };

  /* reset */
  const resetHandler = () => {
    setConceptName("");
    setValidation({
      nameWarning: false,
    });
    setEditConceptData(null);
  };

  /* use effect hook to assign edit data */
  useEffect(() => {
    console.log(editConceptData);
    if (editConceptData) {
      //assign concept name
      editConceptData?.name && setConceptName(editConceptData.name);
    }
  }, [editConceptData]);

  useEffect(() => {
    if (resetAddUpdateConceptPopup) {
      resetHandler();
      setResetAddUpdateConceptPopup(false);
    }
  }, [resetAddUpdateConceptPopup]);

  return (
    <div
      className="offcanvas offcanvas-end border-0"
      tabIndex="-1"
      id="addUpdateConceptPopup"
      aria-labelledby="addLabelPopupLabel"
    >
      <div className="offcanvas-header p-4">
        <h3 className="text-secondary mb-0" id="addLabelPopupLabel">
          {editConceptData ? t("Update Concept") : t("Add Concept")}
        </h3>

        {/* ------- pop up close button start ------- */}
        <button
          type="button"
          id="closeCreateMail"
          className="btn-close p-2 bg-white shadow-none shadow-sm m-0"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
          onClick={resetHandler}
        ></button>
        {/* ------- pop up close button end ------- */}
      </div>

      <div className="offcanvas-body p-4 pt-0">
        {/* ------- concept form section start ------ */}
        <form
          onSubmit={
            editConceptData ? updateConceptHandler : addNewConceptHandler
          }
        >
          {/* ------- concept name section start ------- */}
          <div className="form-group mb-4">
            <label htmlFor="name">{t("Concept Name")}</label>
            <input
              type="text"
              id="name"
              placeholder={t("Enter name")}
              className="form-control"
              value={conceptName}
              onChange={(e) => {
                setConceptName(e.target.value);
                setValidation((prevState) => ({
                  ...prevState,
                  nameWarning: false,
                }));
              }}
            />
            {/* name warning */}
            {validation.nameWarning && (
              <div className="error-message mt-2">
                <p className="d-flex align-items-center gap-1 text-danger">
                  <span className="material-symbols-outlined">warning</span>
                  <span>{t("Please enter concept name")}!</span>
                </p>
              </div>
            )}
          </div>
          {/* ------- concept name section end ------- */}

          {/* ------- concept submit button start ------- */}
          <div className="action">
            <button
              type="submit"
              className="btn btn-primary mw-unset"
              disabled={isSending ? true : false}
              style={{ cursor: isSending ? "not-allowed" : "pointer" }}
            >
              {editConceptData ? t("Update") : t("Save")}
              {isSending && (
                <div
                  className="mx-2 spinner-border spinner-border-sm"
                  role="status"
                >
                  <span className="visually-hidden">Loading...</span>
                </div>
              )}
            </button>
          </div>
          {/* ------- concept submit button end ------- */}
        </form>
        {/* ------- concept form section end ------ */}
      </div>
    </div>
  );
};

export default AddUpdateConceptPopup;
